import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';

interface IProps {
    type?: string;
}

const ProductPreview: FC<IProps> = ({}) => {
    const list = [
        {
            title: 'DELTA 2',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710848532093/sl_ds.png',
            subtitle1: '・1,024Wh容量 / 1,500W定格出力\n・50分で80%充電\n・リン酸鉄リチウムイオン電池搭載で安心の長寿命',
            subtitle2: '・キャンプなどのアウトドア\n・防災・緊急時\n・車中泊',
            href: 'https://jp.ecoflow.com/products/delta-2-portable-power-station',
        },
        {
            title: 'DELTA 2+220Wソーラーパネル',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710848565094/DELTA%202%20%2B%20220W%20(Hot).png',
            subtitle1: '・DELTA 2：1,024Wh容量 / 1,500W定格出力\n・長寿命リン酸鉄リチウムイオン電池搭載\n・220Wソーラーパネル：5.8時間でDELTA 2を満充電',
            subtitle2: '・大人数・連泊キャンプ\n・停電・節電対策\n・防災用品として',
            href: 'https://jp.ecoflow.com/products/delta-2-solar-generator-220w-solar-panel',
        },
        {
            title: 'DELTA Pro',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710848578816/sl_dp.png',
            subtitle1: '・3,600Whの大容量 / 3,000W定格出力\n・長寿命リン酸鉄リチウムイオン電池搭載\n・5種類もの充電方法に対応',
            subtitle2: '・災害時や緊急時の非常用電源として\n・屋外作業やテレワークに\n・車中泊やバンライフのお供に',
            href: 'https://jp.ecoflow.com/products/delta-pro-portable-power-station',
        },
    ];

    return (
        <div className={styled.ProductPreview}>
            <h6 className="propre_title">おすすめのEcoFlow製品はこちら！下記のシーンでEcoFlow製品がよく利用されています</h6>
            <div className="pro_list">
                {list.map((item) => (
                    <div key={item.title} className="pro_list_item">
                        <EditorImg className="img" pc={item.img} />
                        <p className="title">{item.title}</p>
                        <div className="subtitle">
                            <p>特長</p>
                            <p>{item.subtitle1}</p>
                        </div>
                        <div className="subtitle">
                            <p>利用シーン</p>
                            <p>{item.subtitle2}</p>
                        </div>
                        <EditorLink
                            className="btn"
                            href={item.href}
                            target="_blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: item.title,
                                position: 'EcoCredits day',
                            }}
                        >
                            詳しくはこちら
                        </EditorLink>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductPreview;
